type ReassignablePermissions = {
    assign: boolean;
    editState: boolean;
    editOutcome: boolean;
};

/**
 * Whether the current user can complete a v3 reassignment of a visit.
 *
 * The reassign submit writes the clinician, sets the visit state to unscheduled, and clears the
 * outcome, so the backend requires all three of these permissions for the edit to succeed. The
 * date is written via `tentativeDate`, which the backend does not permission-check, so no date
 * permission is needed here.
 */
export const isReassignableVisit = (permissions: ReassignablePermissions): boolean =>
    permissions.assign && permissions.editState && permissions.editOutcome;
